import React, { useEffect } from 'react';
import Search from "../Search/Search";
import Layer from "../QuyHoach/Layer";
import Server from "../Menu/Server";
import Location from "../Menu/Location";
import ZonePanel from "../QuyHoach/ZonePanel";
import PriceFilter from "../PriceTable/PriceFilter";

const ContentPopupPanel = ({ route }) => {

    // console.log(route)
    switch (route) {
        case "search":
            return (
                <Search />
            );
        case "layer":
            return (
                <Layer />
            );
        case "server":
            return (
                <Server />
            );
        case "location":
            return (
                <Location />
            );
        case "zone":
            return (
                <ZonePanel />
            );
        case "price":
            return (
                <PriceFilter />
            );

        // case "panelQuyHoachInfo":
        //     return (
        //        <PanelQuyHoachInfo />
        //     );
        default:
            return null
    }
}

export default ContentPopupPanel
